import { canvasCssValue } from '@lib/canvasx/util';

interface RGBA {
  name: string;
  color: string;
  opacity: number;
}

interface ButtonStyle {
  background: RGBA;
  icon: RGBA;
}

export type ButtonState = 'default' | 'selected' | 'hovered';

export const ButtonStyles: Record<ButtonState, ButtonStyle> = {
  default: {
    background: {
      name: '--theme-rgb-tertiary-background',
      color: '241, 241, 241',
      opacity: 0.7,
    },
    icon: {
      name: '--theme-rgb-primary-text',
      color: '51, 51, 51',
      opacity: 0.8,
    },
  },
  hovered: {
    background: {
      name: '--theme-rgb-primary-background',
      color: '255, 255, 255',
      opacity: 1,
    },
    icon: {
      name: '--theme-rgb-primary-text',
      color: '51, 51, 51',
      opacity: 1,
    },
  },
  selected: {
    background: {
      name: '--theme-rgb-secondary-background',
      color: '247, 247, 247',
      opacity: 1,
    },
    icon: {
      name: '--theme-rgb-primary-text',
      color: '51, 51, 51',
      opacity: 0.8,
    },
  },
};

export const formattedRgba = (rgba: RGBA) =>
  `rgba(${canvasCssValue(rgba.name, rgba.color)}, ${rgba.opacity})`;
